import AntdDrawer            from 'antd/lib/drawer';
import { DrawerProps }       from 'antd/lib/drawer';
import DrawerContext         from '@widesk-ui/contexts/DrawerContext';
import { DrawerContextType } from '@widesk-ui/contexts/DrawerContext';
import { observer }          from 'mobx-react-lite';

const Drawer = observer(({
	context, ...props }: DrawerProps & { context?: DrawerContextType }
) => {
	const component = <AntdDrawer footer={context?.footer || props.footer} {...props} />;

	return context ? (
		<DrawerContext.Provider value={{ ...context }}>
			{component}
		</DrawerContext.Provider>
	) : component;
});

export default Drawer;